import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XIcon } from '../../icons';
import { cn } from '../../utils';
import { useModal } from './context';
export function ModalHeader({ children, className }) {
    const { close } = useModal();
    return (_jsxs("div", { className: cn('flex p-stack-section justify-between items-center w-full border-b border-border', className), children: [_jsx("div", { className: "flex flex-col w-full gap-stack-dense", children: children }), _jsx("button", { type: "button", onClick: close, className: "p-stack-tight border border-transparent hover:border-border hover:bg-surface rounded-surface transition-colors", children: _jsx(XIcon, { className: "size-4 text-fg-muted" }) })] }));
}
